import { useTranslation } from 'react-i18next';

import { useFeature } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { Tabs } from '@treams/treams-ui';

type Tab = {
	conditions: boolean[];
	title: string;
	path: string;
	selected?: boolean;
	exact?: boolean;
};

export default function GoalsTabs() {
	const { t } = useTranslation();
	const hasGoals = useFeature(graphql.FeatureName.Goals);
	const hasTeamGoals = useFeature(graphql.FeatureName.TeamGoals);

	const evaluateConditions = (conditions: boolean[]) => {
		return conditions.every(Boolean);
	};

	const tabs: Tab[] = [
		{
			conditions: [hasGoals],
			title: t('goals.tab.personal.title'),
			path: '/goals',
			selected: true,
		},
		{
			conditions: [hasTeamGoals],
			title: t('goals.tab.collective.title'),
			path: '/goals/collective',
			exact: false,
		},
		{
			conditions: [hasTeamGoals],
			title: t('goals.tab.organization.title'),
			path: '/goals/organization',
			selected: true,
		},
	];

	return (
		<Tabs.Container>
			{tabs.map(
				(tab, index) =>
					evaluateConditions(tab.conditions) && (
						<Tabs.Item
							key={index}
							title={tab.title}
							path={tab.path}
							selected={tab.selected}
							exact={tab.exact}
						/>
					),
			)}
		</Tabs.Container>
	);
}
